import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AdminUser } from "@/types";
import { tokenService } from "@/services/tokenService";

interface AdminAuthStore {
  adminUser: AdminUser | null;
  isAuthenticated: boolean;

  // Actions
  setUser: (user: AdminUser | null) => void;
  setAuthenticated: (isAuth: boolean) => void;
  logout: () => void;
}

export const useAdminAuthStore = create<AdminAuthStore>()(
  persist(
    (set) => ({
      adminUser: null,
      isAuthenticated: false,

      setUser: (user) => {
        set({ adminUser: user, isAuthenticated: !!user });
      },

      setAuthenticated: (isAuth) => {
        set({ isAuthenticated: isAuth });
      },

      logout: () => {
        tokenService.clear();
        set({
          adminUser: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: "admin-auth-storage",
      partialize: (state) => ({
        adminUser: state.adminUser,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
